import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router-for-react18';
import setupStore from './store/setupStore';
import App from './App';
import * as jquery from "jquery";
import { createBrowserHistory, History, LocationDescriptor, LocationDescriptorObject } from 'history';
import queryString from 'query-string';
import reportWebVitals from './reportWebVitals';
import RedirectLoader from './RedirectLoader';

import 'bootstrap/dist/css/bootstrap.css';
import './index.css';

Object.assign(global, {
  $: jquery,
  jQuery: jquery,
  recommendationWidget: {}
});

type CreateHistory<O, H> = (options?: O) => History & H

function preserveQueryParameters(history: History, preserve: string[], location: LocationDescriptorObject): LocationDescriptorObject {
  const currentQuery = queryString.parse(history.location.search)

  if (currentQuery) {
    const preservedQuery: { [key: string]: unknown } = {}
    for (let p of preserve) {
      const v = currentQuery[p]
      if (v) {
        preservedQuery[p] = v
      }
    }
    if (location.search) {
      Object.assign(preservedQuery, queryString.parse(location.search))
    }
    location.search = queryString.stringify(preservedQuery)
  }

  return location
}

function createLocationDescriptorObject(location: LocationDescriptor, state?: History.LocationState): LocationDescriptorObject {
  return typeof location === 'string' ? { pathname: location, state } : location
}

function createPreserveQueryHistory<O, H>(createHistory: CreateHistory<O, H>,
  queryParameters: string[]): CreateHistory<O, H> {
  return (options?: O) => {
    const history = createHistory(options)
    const oldPush = history.push, oldReplace = history.replace
    history.push = (path: LocationDescriptor, state?: History.LocationState) =>
      oldPush.apply(history, [preserveQueryParameters(history, queryParameters, createLocationDescriptorObject(path, state))])
    history.replace = (path: LocationDescriptor, state?: History.LocationState) =>
      oldReplace.apply(history, [preserveQueryParameters(history, queryParameters, createLocationDescriptorObject(path, state))])
    return history
  }
}


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href') as string;
const history = createPreserveQueryHistory(createBrowserHistory, ['lang'])({ basename: baseUrl });

// Get the application-wide store instance, prepopulating with state from the server where available.
const store = setupStore(history);
root.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <React.StrictMode>
        <RedirectLoader>
          <App />
        </RedirectLoader>
      </React.StrictMode>
    </ConnectedRouter>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
